import type { StateCreator } from 'zustand';

export interface ConfigurationCriteriaProductsSlice {
  clearParsedSkus: () => void;
  invalidSkus: string[];
  setInvalidSkus: (skus: string[]) => void;
  setValidSkus: (skus: string[]) => void;
  validSkus: string[];
}

export const createConfigurationCriteriaProductsSlice: StateCreator<
  ConfigurationCriteriaProductsSlice
> = (set) => ({
  validSkus: [],
  invalidSkus: [],
  lastImportedSkus: [],
  setValidSkus: (skus) => set({ validSkus: skus }),
  setInvalidSkus: (skus) => set({ invalidSkus: skus }),
  clearParsedSkus: () => set({ validSkus: [], invalidSkus: [] }),
});
